import React from 'react';
import { Users, TrendingUp, ShieldCheck } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

function FeatureCard({ Icon, title, body }) {
  return (
    <div
      className="relative rounded-2xl bg-white border border-gray-200 p-8 md:p-10 shadow-[0_8px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_16px_40px_rgba(0,0,0,0.08)] hover:-translate-y-0.5 transition-all duration-300"
      data-testid="why-choose-card"
    >
      {/* Icon tile — amber accent rail signals brand without dominating */}
      <div className="w-12 h-12 rounded-xl bg-[#fff5e0] flex items-center justify-center mb-6">
        <Icon className="w-6 h-6 text-[#c9820e]" strokeWidth={2} />
      </div>
      <h3 className="text-[20px] md:text-[22px] font-bold tracking-tight text-gray-900 mb-3 leading-snug">
        {title}
      </h3>
      <p className="text-gray-600 text-[16px] md:text-[17px] leading-[1.7]">{body}</p>
    </div>
  );
}

export default function WhyChoose() {
  const { t } = useI18n();
  const items = [
    { Icon: Users, title: t.why.one.title, body: t.why.one.body },
    { Icon: TrendingUp, title: t.why.two.title, body: t.why.two.body },
    { Icon: ShieldCheck, title: t.why.three.title, body: t.why.three.body },
  ];

  return (
    <section className="py-16 md:py-24 bg-[#f7f7f9]">
      <div className="zh-container">
        {/* Eyebrow + heading — matches About section rhythm. Removed the
            hard `uppercase tracking-wide` treatment on H2 because it read
            as noisy banner text; a small amber eyebrow + tight display
            heading is cleaner and more modern. */}
        <div className="mb-10 md:mb-14 max-w-3xl">
          <div className="inline-block text-[12px] md:text-[13px] font-bold uppercase tracking-[0.22em] text-[#f5a623] mb-4">
            Why ZHELTA
          </div>
          <h2 className="text-[40px] md:text-6xl font-extrabold tracking-tight text-gray-900 leading-[1.05] mb-4">
            {t.why.title}
          </h2>
          <div className="h-1.5 w-24 rounded-full bg-[#f5a623] mb-5" />
          {t.why.subtitle && (
            <p className="text-gray-600 text-lg md:text-xl leading-[1.7]">
              {t.why.subtitle}
            </p>
          )}
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, i) => (
            <FeatureCard key={i} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
}
